
import angular from 'angular';

import fileChange from './file-change';

export default angular.module('directive.file-change', [])
	.directive('fileChange', fileChange)
	.name;



// WEBPACK FOOTER //
// ./src/directive/file-change/index.js